import TravelPassproduct from "../pages/TravelPassproduct";
import TpShopOld from "../pages/TpShopOld";
import MyTravelPass from "../pages/MyTravelPass";


const ROUTES = [
    {
        path: '/buy-travelpass-classic',
        pageElement: (pageDetails) => {
           return <TpShopOld  pageDetails = {pageDetails} />
        },
        exact: true
    },
    {
        path: '/:pos/buy-travelpass-classic',
        pageElement: (pageDetails) => {
           return <TpShopOld  pageDetails = {pageDetails} />
        },
        exact: true
    },
    {
        path: '/buy-travelpass',
        pageElement: (pageDetails) => {
           return <TravelPassproduct  pageDetails = {pageDetails} />
        },
        exact: true
    },
    {
        path: '/:pos/buy-travelpass',
        pageElement: (pageDetails) => {
           return <TravelPassproduct  pageDetails = {pageDetails} />
        },
        exact: true
    },
    {
        path: '/my-travelpass',
        pageElement: (pageDetails) => {
           return <MyTravelPass  pageDetails = {pageDetails} />
        },
        exact: true
    },
    {
        path: '/:pos/my-travelpass',
        pageElement: (pageDetails) => {
           return <MyTravelPass  pageDetails = {pageDetails} />
        },
        exact: true
    }
];
export default ROUTES;